import { isMarkdownRendererEnabled } from '@/config/env/responseUi.js'
import Phase1MarkdownOrInferred from './phase1MarkdownOrInferred'
import { splitPhase1Text } from './phase1ContentDisplay'
import { renderTextBlock } from './renderTextBlock'

/**
 * Chooses how response text is rendered (Stages 2.4 and 4).
 *
 * Inference is deferred while a turn is streaming, and stays on the markdown
 * renderer after that stream so a late card cannot remount the typed answer.
 */
export default function Phase1ResponseText({ text, citations = [], streaming = false }) {
  if (!isMarkdownRendererEnabled()) {
    return splitPhase1Text(text).map((block, index) =>
      renderTextBlock(block, citations, `phase1-text-${index}`),
    )
  }

  return <Phase1MarkdownOrInferred text={text} citations={citations} streaming={streaming} />
}
